import * as THREE from 'three';
import Experience from "../Experience.js";
import { TransformControls } from 'three/examples/jsm/controls/TransformControls.js'
import PcMonitorScreenManager from "./Monitor.js";
import CoffeeSteamVFXManager from "./CoffeeSteam.js";
import MacbookScreenManager from "./MacbookScreen.js";
import AbridgedCVManager from './AbridgedCV.js';
import LongCVManager from './LongCV.js';
import CatManager from './Cats.js';
import * as SkeletonUtils from 'three/examples/jsm/utils/SkeletonUtils.js';

export default class Workden
{
    constructor()
    {
        // get ref to Experience singleton
        this.experienceRef = new Experience();
        this.threeJSsceneRef = this.experienceRef.threeJSscene;
        this.resourcesRef = this.experienceRef.resources;        
        this.timeRef = this.experienceRef.time;
        this.debugRef = this.experienceRef.debug;
        this.materialsRef = this.experienceRef.materials;
        this.postProcessingRef = this.experienceRef.postProcessing;
        this.cameraRef = null;
              
        this.sceneReady = false;

        // Debug
        if (this.debugRef.active)
        {
            this.debugFolder = this.debugRef.ui.addFolder('Workden');
        }

        // Resource
        this.workDenSceneBakedItems01 = this.resourcesRef.objectsLoaded.workDenSceneMerged001;
        this.workDenSceneBakedItems02 = this.resourcesRef.objectsLoaded.workDenSceneMerged002;
        this.workDenSceneMaterialMappedItems = this.resourcesRef.objectsLoaded.workDenSceneMaterialMappedObjects;
        this.workDenSceneBakedPhotoTextureObjects = this.resourcesRef.objectsLoaded.workDenSceneMergedPhotoTextureObjects;
        this.workDenSceneMiscObjects = this.resourcesRef.objectsLoaded.workDenSceneMiscObjects;        
        this.catRigAndModel = this.resourcesRef.objectsLoaded.cat;
        
        // console.log(this.catRigAndModel);
        // console.log(this.catRigAndModel.scene);
        // console.log(this.catRigAndModel.scene.children[0]);
        
        //console.log(this.resourcesRef.materialsLoaded);
        //console.log(this.workDenSceneBakedItems);
        //console.log(this.workDenSceneMaterialMappedItems);

        this.parseModels();
        this.setMaterials();   
        this.populateThreeJSScene();
        this.initializeSpecialObjectBehaviors();
        this.initializeInteractiveoBjects();
    }

    parseModels()
    {
        // Baked Objects
        this.bakedItemsModel01 = this.workDenSceneBakedItems01.scene.children[0];        
        this.bakedItemsModel02 = this.workDenSceneBakedItems02.scene.children[0];
        //this.bakedItemsModel01.rotation.y =  - Math.PI / 2;
        this.bakedItemsModel01.scale.set(1, 1, 1);
        //this.bakedItemsModel02.rotation.y =  - Math.PI / 2;
        this.bakedItemsModel02.scale.set(1, 1, 1);

        this.workDenSceneMiscObjects = this.workDenSceneMiscObjects.scene;
        //this.workDenSceneMiscObjects.rotation.y =  - Math.PI / 2;
        this.workDenSceneMiscObjects.scale.set(1, 1, 1);

        this.workDenScenePhotoTexturesBakedModel = this.workDenSceneBakedPhotoTextureObjects.scene.children[0];
        //this.workDenScenePhotoTexturesBakedModel.rotation.y =  - Math.PI / 2;
        this.workDenScenePhotoTexturesBakedModel.scale.set(1, 1, 1);

        // Interactables
        this.materialMappedItemsModel = this.workDenSceneMaterialMappedItems.scene;
        //this.materialMappedItemsModel.rotation.y =  - Math.PI / 2;
        this.materialMappedItemsModel.scale.set(1, 1, 1);

        this.linkedInLogo = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'linkedInLogo');
        this.behanceLogo = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'behanceLogo');        
        this.resume = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'resume');
        this.resumeLongCloseButton = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'resumeLongCloseButton');
        this.resumeLongOpenButton = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'resumeLongOpenButton');        
        this.resume.attach(this.resumeLongCloseButton);
        this.resume.attach(this.resumeLongOpenButton);
        this.resumeAbridged = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'resumeAbridged');        
        this.resumeAbridgedCloseButton = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'resumeAbridgedCloseButton');
        this.resumeAbridgedOpenButton = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'resumeAbridgedOpenButton');
        this.resumeAbridged.attach(this.resumeAbridgedCloseButton);
        this.resumeAbridged.attach(this.resumeAbridgedOpenButton);
        this.githubLogo = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'githubLogo');
        this.monitorScreen = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'monitorScreen');
        this.draftingTableSketch = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'draftingTableSketchHitbox');
        this.documentFolder = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'documentFolder');
        this.backNote1 = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'backNote001');
        this.backNote2 = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'backNote002');
        this.backNote3 = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'backNote003');
        this.monitorONOFFbutton = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'monitorONOFFbutton');
        this.backNote4 = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'backNote004');        
        this.backNote5 = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'backNote005');
        this.backNote6 = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'backNote006');
        this.backNote7 = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'backNote007');
        this.backNote8 = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'backNote008');
        this.backNote9 = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'backNote009');
        this.backNote10 = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'backNote010');
        this.macbookScreen = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'macbookScreen');
        this.cricketEquipment = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'cricketEquipment');       
        
        // Non Interactive Objects
        this.unityLogo = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'unityLogo');
        this.unrealLogo = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'unrealLogo');
        this.photoshopLogo = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'photoshopLogo');        
        this.blenderLogo = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'blenderLogo');        
        this.threeJsLogo = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'threeJsLogo');
        this.googleHomeLights = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'googleHomeLights');
        this.treeLampBulb1 = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'treeLampLightBulb001');
        this.treeLampBulb2 = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'treeLampLightBulb002');
        this.treeLampShadesInnerSide = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'treeLampShadeInnerSide');
        //this.treeLampShadesInner = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'treeLampShade');
        this.hangingLampLight = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'hangingLampLightBulb');
        this.hangingLampShade = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'hangingLampShade');
        
        this.cpuConnectors = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'cpuConnectors');
        this.cpuCooler = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'cpuCooler');
        this.pcRAM = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'cpuRAM');
        this.desktopPcCabinet = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'desktopPCCabinet');        
        this.gpuName = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'gpuNameLED');
        this.nvidiaLogo = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'nvidiaLogo');
        this.cpuRadiatorFan1 = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'cpuRadiatorFan001');
        this.cpuRadiatorFan2 = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'cpuRadiatorFan002');
        this.cpuRadiatorFanBolts = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'cpuRadiatorFanBolts');        

        this.macbookBacklitKeyboardLights = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'macbookKeysBacklight');
        this.kurzgezagtLogo = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'kurzgezagtLogo');
        this.phoneScreen = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'cellPhoneScreen');
        this.hololensLED = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'holoLensLED');        

        // Animated Objects
        this.gamingChairSeat = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'deskChairSeat');
        this.pcCabinetFan = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'cpuFan');
        this.gpuFan = this.materialMappedItemsModel.children[0].children.find(child => child.name === 'gpuFan');
        
        // Animated Objects and Interactives        
        this.catMimi = SkeletonUtils.clone(this.catRigAndModel.scene);
        this.catMimiBodyMesh = this.catMimi.children[0].children[0];
        //this.catMimi.scale.set(25, 25, 25);
        //console.log(this.catMimi);
        this.catCindy = SkeletonUtils.clone(this.catRigAndModel.scene);
        this.catCindyBodyMesh = this.catCindy.children[0].children[0];
        //console.log(this.catCindy);
        //this.catCindy.scale.set(25, 25, 25);
        

        this.deskCoffeeCupSteamMarker = this.workDenSceneMiscObjects.children[0].children.find(child => child.name === 'deskCoffeeCupSteamMarker');
        this.rugCoffeeCupSteamMarker = this.workDenSceneMiscObjects.children[0].children.find(child => child.name === 'rugCoffeeCupSteamMarker');
        this.catTreePositionMarker01 = this.workDenSceneMiscObjects.children[0].children.find(child => child.name === 'catTreeRestPositionMarker01');
        this.catTreePositionMarker02 = this.workDenSceneMiscObjects.children[0].children.find(child => child.name === 'catTreeRestPositionMarker02');

        //Test object        
        // const cubeGeometry = new THREE.BoxGeometry(1000, 1000, 1000)
        // const cubeMaterial = new THREE.MeshBasicMaterial({
        //     color: '#ffffff',
        //     wireframe: false
        // })
        // this.cubeMesh = new THREE.Mesh(cubeGeometry, cubeMaterial);
        // var globalPosition = new THREE.Vector3();                
        // //this.cat.getWorldPosition(globalPosition);
        // this.resumeAbridged.getWorldPosition(globalPosition);
        // this.cubeMesh.position.copy(globalPosition);
        // this.resumeAbridged.attach(this.cubeMesh);
        //this.threeJSsceneRef.add(this.cubeMesh);

        // const geometry = new THREE.PlaneGeometry( 1, 1 );        
        // const plane = new THREE.Mesh( geometry, this.materials.monitorScreenMaterial );
        // this.threeJSsceneRef.add( plane )

        // const boxHelper = new THREE.BoxHelper(this.resumeAbridged, 0xffffff); // Red bounding box
        // this.threeJSsceneRef.add(boxHelper);

        //console.log('Workden Scene Models Parsed');
    }

    setMaterials()
    {
        // Baked Texture Objects
        this.bakedItemsModel01.material = this.materialsRef.workDenSceneBakedItemsModelMaterial01;
        this.bakedItemsModel02.material = this.materialsRef.workDenSceneBakedItemsModelMaterial02;
        this.workDenScenePhotoTexturesBakedModel.material = this.materialsRef.workDenScenePhotoTexturedObjectsMaterial;
        for (var i=0; i<this.cricketEquipment.children.length; i++)
        {                
            this.cricketEquipment.children[i].material =  this.materialsRef.cricketEquipmentMaterial;
        }

        // Texture mapped Objects
        this.resume.material = this.materialsRef.resumeMaterial;
        this.resumeLongCloseButton.material = this.materialsRef.resumeCloseButtonMaterial;
        this.resumeLongOpenButton.material = this.materialsRef.resumeOpenButtonMaterial;
        this.resumeAbridged.material = this.materialsRef.resumeAbridgedMaterial;
        this.resumeAbridgedCloseButton.material = this.materialsRef.resumeCloseButtonMaterial;
        this.resumeAbridgedOpenButton.material = this.materialsRef.resumeOpenButtonMaterial;
        this.kurzgezagtLogo.material = this.materialsRef.kurzgezagtLogoMaterial;
        this.phoneScreen.material = this.materialsRef.phoneScreenMaterial;
        this.draftingTableSketch.material = this.materialsRef.draftingTablePaintingMaterial;
        this.backNote1.material = this.materialsRef.stickyNoteMaterial;
        this.backNote2.material = this.materialsRef.stickyNoteMaterial;
        this.backNote3.material = this.materialsRef.stickyNoteMaterial;
        this.backNote4.material = this.materialsRef.stickyNoteMaterial;
        this.monitorONOFFbutton.material = this.materialsRef.monitorONOFFbuttonMaterial;
        this.backNote5.material = this.materialsRef.stickyNoteMaterial;
        this.backNote6.material = this.materialsRef.stickyNoteMaterial;
        this.backNote7.material = this.materialsRef.stickyNoteMaterial;
        this.backNote8.material = this.materialsRef.stickyNoteMaterial;
        this.backNote9.material = this.materialsRef.stickyNoteMaterial;
        this.backNote10.material = this.materialsRef.stickyNoteMaterial;
        this.catMimiBodyMesh.material = this.materialsRef.catMimiMaterial;        
        for (var i=0; i<this.cricketEquipment.children.length; i++)
        {                
            this.cricketEquipment.children[i].material =  this.materialsRef.cricketEquipmentMaterial;
        }

        // Interactive Glowing Objects
        for (var i=0; i<this.linkedInLogo.children.length; i++)
        {
            //console.log(this.linkedInLogo.children[i]);
            this.linkedInLogo.children[i].material = this.materialsRef.linkedInLogoMaterials[i];
        }
        for (var i=0; i<this.behanceLogo.children.length; i++)
        {
            //console.log(this.linkedInLogo.children[i]);
            this.behanceLogo.children[i].material = this.materialsRef.behanceLogoMaterials[i];
        }
        this.githubLogo.material = this.materialsRef.githubLogoMaterial;
        for (var i=0; i<this.desktopPcCabinet.children.length; i++)
        {             
            this.desktopPcCabinet.children[i].material = this.materialsRef.pcCabinetMaterials[i];
        }
        for (var i=0; i<this.documentFolder.children.length; i++)
        {                
            this.documentFolder.children[i].material = this.materialsRef.documentFolderMaterials[i];
        }

        // Non Interactable glowing objects
        for (var i=0; i<this.unityLogo.children.length; i++)
        {             
            this.unityLogo.children[i].material = this.materialsRef.unityLogoMaterials[i];
        }            
        this.unrealLogo.material = this.materialsRef.unrealLogoMaterial;
        for (var i=0; i<this.photoshopLogo.children.length; i++)
        {             
            this.photoshopLogo.children[i].material = this.materialsRef.photoshopLogoMaterials[i];
        }
        for (var i=0; i<this.blenderLogo.children.length; i++)
        {             
            this.blenderLogo.children[i].material = this.materialsRef.blenderLogoMaterials[i];
        }
        this.threeJsLogo.material = this.materialsRef.threeJsLogoMaterial;
        for (var i=0; i<this.googleHomeLights.children.length; i++)
        {             
            this.googleHomeLights.children[i].material = this.materialsRef.googleHomeLEDMaterials[i];
        }
        //console.log(this.materialMappedItemsModel.children[0]);
        this.treeLampBulb1.material = this.materialsRef.lampBulbMaterial;
        this.treeLampBulb2.material = this.materialsRef.lampBulbMaterial;
        this.treeLampShadesInnerSide.material = this.materialsRef.treeLampShadeInnerMaterial;
        this.hangingLampLight.material = this.materialsRef.lampBulbMaterial;
        this.hangingLampShade.material = this.materialsRef.hangingLampShadeMaterial;
        this.pcCabinetFan.material = this.materialsRef.pcRAMMaterials[0];
        this.cpuConnectors.material = this.materialsRef.cpuConnectorsMaterial;
        for (var i=0; i<this.cpuCooler.children.length; i++)
        {             
            this.cpuCooler.children[i].material = this.materialsRef.cpuCoolerMaterials[i];
        }
        for (var i=0; i<this.pcRAM.children.length; i++)
        {             
            this.pcRAM.children[i].material = this.materialsRef.pcRAMMaterials[i];
        }        
        for (var i=0; i<this.gpuFan.children.length; i++)
        {                
            this.gpuFan.children[i].material = this.materialsRef.gpuFanMaterials[i];
        }
        this.gpuName.material = this.materialsRef.gpuNameMaterial;
        this.nvidiaLogo.material = this.materialsRef.gpuNameMaterial;
        for (var i=0; i<this.cpuRadiatorFan1.children.length; i++)
        {                
            this.cpuRadiatorFan1.children[i].material = this.materialsRef.pcCabinetRadiatorFanMaterials[i];
            this.cpuRadiatorFan2.children[i].material = this.materialsRef.pcCabinetRadiatorFanMaterials[i];
        }
        this.macbookBacklitKeyboardLights.material = this.materialsRef.macbookBacklitKeyboardLightMaterial;
        this.hololensLED.material = this.materialsRef.hololensLEDMaterial;        
        this.monitorScreen.material = this.materialsRef.desktopMonitorScreenMaterial;        
        for (var i=0; i<this.gamingChairSeat.children.length; i++)
        {                
            this.gamingChairSeat.children[i].material = this.materialsRef.gamingChairSeatMaterials[i];
        }        

        //console.log('Workden Scene Materials Mapped');
    }

    populateThreeJSScene()
    {
        this.threeJSsceneRef.add(this.bakedItemsModel01);
        this.threeJSsceneRef.add(this.bakedItemsModel02);
        this.threeJSsceneRef.add(this.workDenScenePhotoTexturesBakedModel);
        this.threeJSsceneRef.add(this.materialMappedItemsModel);
        
        this.threeJSsceneRef.add(this.catMimi);
        //this.threeJSsceneRef.add(this.catCindy);

        //console.log("Populated Workden Scene Objects");
    }

    initializeSpecialObjectBehaviors()
    {
        //console.log("initializing special object behaviors");

        this.pcMonitorScreenManager = new PcMonitorScreenManager(this);
        this.macbookScreenManager = new MacbookScreenManager(this);
        this.deskCoffeeCupSteamManager = new CoffeeSteamVFXManager(this.deskCoffeeCupSteamMarker);
        this.rugCoffeeCupSteamManager = new CoffeeSteamVFXManager(this.rugCoffeeCupSteamMarker);
        this.abridgedCV = new AbridgedCVManager(this);
        this.longCV = new LongCVManager(this);
        this.catManager = new CatManager(this);

        this.sceneReady = true;

        //console.log("initializing special object behaviors - COMPLETE");
    }

    setupWorkdenSounds()
    {
        this.cameraRef = this.experienceRef.camera.cameraInstance;
       
        // Create listener and add to camera
        this.workdenSoundsListener = new THREE.AudioListener();
        this.cameraRef.add(this.workdenSoundsListener);

        this.workdenBackgroundSfx = new THREE.Audio(this.workdenSoundsListener);
        this.backgroundNoiseSFXBuffer = this.resourcesRef.objectsLoaded.workdenBackgroundNoise;
        this.workdenBackgroundSfx.stop();
        this.workdenBackgroundSfx.setBuffer(this.backgroundNoiseSFXBuffer);
        this.workdenBackgroundSfx.setLoop(true);
        this.workdenBackgroundSfx.setVolume(0.5);
        this.workdenBackgroundSfx.play();

        this.workdenPCClickedSfx = new THREE.Audio(this.workdenSoundsListener);
        this.computerClickedSFXBuffer = this.resourcesRef.objectsLoaded.clickSound1;

        //console.log("Workden sound setup complete");
    }

    initializeInteractiveoBjects()
    {
        // Objects to test
        this.interactableObjects = [
            // Interactables
            this.behanceLogo,
            this.linkedInLogo,
            this.githubLogo,
            this.resume,
            this.resumeAbridged,
            this.monitorScreen,
            this.threeJsLogo,
            this.draftingTableSketch,
            this.documentFolder,
            this.backNote1,
            this.backNote2,
            this.backNote3,
            this.backNote4,
            this.monitorONOFFbutton,
            this.backNote5,
            this.backNote6,
            this.backNote7,
            this.desktopPcCabinet.children[1],
            this.macbookScreen,
            //this.resumeAbridgedOpenButton,
            //this.resumeAbridgedCloseButton,
            this.catMimiBodyMesh,
            //this.catCindyBodyMesh,
            this.backNote8,
            this.backNote9,
            this.backNote10,
            this.cricketEquipment
        ]
    }

    playComputerClickSFX()
    {
        this.workdenPCClickedSfx.stop();
        this.workdenPCClickedSfx.setBuffer(this.computerClickedSFXBuffer);
        this.workdenPCClickedSfx.setLoop(false);
        this.workdenPCClickedSfx.setVolume(1);
        this.workdenPCClickedSfx.play();
    }

    update()
    {
        if (this.sceneReady)
        {
            //console.log("Updating Fox animation mixer");        
            //this.animation.mixer.update(this.timeRef.delta * 0.001);        

            if (this.gamingChairSeat)
            {
                this.gamingChairSeat.rotation.y = Math.sin(this.timeRef.elapsedTime * 0.0002)
            }
    
            if(this.gpuFan)
            {
                this.gpuFan.rotation.y += 0.02;
            }
    
            if(this.pcCabinetFan)
            {
                this.pcCabinetFan.rotation.x += 0.02;
            }
    
            if(this.cpuRadiatorFan1)
            {
                this.cpuRadiatorFan1.rotation.y += 0.03;
            }
    
            if(this.cpuRadiatorFan2)
            {
                this.cpuRadiatorFan2.rotation.y += 0.03;
            }
    
            if (this.materialsRef)
            {
                this.materialsRef.update();
            }
    
            if (this.pcMonitorScreenManager)
            {
                this.pcMonitorScreenManager.update();
            }
    
            if (this.macbookScreenManager)
            {
                this.macbookScreenManager.update();
            }
    
            if (this.deskCoffeeCupSteamManager)
            {
                this.deskCoffeeCupSteamManager.update();
            }
    
            if (this.rugCoffeeCupSteamManager)
            {
                this.rugCoffeeCupSteamManager.update();
            }
    
            // if (this.abridgedCV)
            // {
            //     this.abridgedCV.update();
            // }
    
            if (this.catManager)
            {
                this.catManager.update();
            }            
        }

        if (!this.cameraRef)
        {
            // Since Audio Listener requires an active Camera in the scene
            this.cameraRef = this.experienceRef.camera;
            this.setupWorkdenSounds();
        }

    }
}